import React, { useEffect, useState } from 'react';
import client, { apiCall } from '../../api/client';
import StatCard from '../../components/StatCard';
import Loader from '../../components/Loader';

export default function AdminOverview() {
  const [counts, setCounts] = useState({ networks: 0, providers: 0, plans: 0, users: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      apiCall(client.get('/network/admin/get_list')).catch(() => []),
      apiCall(client.get('/rpc_provider/admin/get_list')).catch(() => []),
      apiCall(client.get('/credit_plan/admin/get_list')).catch(() => []),
      apiCall(client.get('/users/admin/get_users', { params: { page: '1' } })).catch(() => ({ totalCount: 0 })),
    ]).then(([networks, providers, plans, users]) => {
      setCounts({
        networks: networks.length,
        providers: providers.length,
        plans: plans.length,
        users: users.totalCount || 0,
      });
    }).finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <h1>Admin Overview</h1>
      {loading ? (
        <Loader label="Loading overview..." />
      ) : (
        <div className="stat-grid">
          <StatCard label="Networks" value={counts.networks} linkTo="/admin/networks" />
          <StatCard label="RPC Providers" value={counts.providers} linkTo="/admin/rpc-providers" />
          <StatCard label="Plans" value={counts.plans} linkTo="/admin/plans" />
          <StatCard label="Users" value={counts.users} linkTo="/admin/users" />
        </div>
      )}
    </div>
  );
}
